import { render, staticRenderFns } from "./VendorDynamicForm.vue?vue&type=template&id=f1192878&"
import script from "./VendorDynamicForm.vue?vue&type=script&lang=js&"
export * from "./VendorDynamicForm.vue?vue&type=script&lang=js&"
import style0 from "./VendorDynamicForm.vue?vue&type=style&index=0&id=f1192878&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports